import React from 'react';
import { Row, Col, Typography } from 'antd';

const { Text } = Typography;

const CrmInfoRow = ({ label, children }) => {
  return (
    <Row style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0' }} className='gap-4'>
      <Col span={6}>
        <Text className='text-color-dark-text text-sm font-normal'>{label}</Text>
      </Col>
      <Col className='!flex'>{children}</Col>
    </Row>
  );
};

export default CrmInfoRow;
